// extracted by mini-css-extract-plugin
module.exports = {"divider":"CardPicker_divider__31kfc","boardLimit":"CardPicker_boardLimit__3qHCp"};